import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Section, SectionInner } from '../../components/Shared/Section';
import { injectIntl } from 'react-intl';
import { toastr } from 'react-redux-toastr';
import Header from '../../components/Header/Header';
import * as instrumentActions from '../../redux/actions/instrumentActions';
import * as firmwareActions from '../../redux/actions/firmwareActions';
import * as accountActions from '../../redux/actions/accountActions';
import styles from './DevicesPage.module.scss';
import RegisterInstrumentModal from './RegisterInstrumentModal';
import Spinner from '../../components/Shared/Loaders/Spinner';
import Devices from '../../components/Devices/Devices';
import { toastrOptions } from '../../constants/toastrOptions';

class DevicesPage extends Component {
  constructor(props) {
    super(props);

    this.intl = props.intl;

    this.state = {
      showRegisterInstrumentModal: false,
      fullModal: false,
      showDownloadFirmwareModal: false,
      showDownloadGatewayModal: false,
    };

    this.actAsOther = this.props.match.params && this.props.match.params.userId ? true : false;

    this.showRegisterInstrumentModal = this.showRegisterInstrumentModal.bind(this);
    this.hideRegisterInstrumentModal = this.hideRegisterInstrumentModal.bind(this);

    this.shareInstrumentPatients = this.shareInstrumentPatients.bind(this);
    this.getCurrentUserId = this.getCurrentUserId.bind(this);
  }

  componentDidMount() {
    //Cannot act as if not SuperAdmin or AdminLvX
    if (
      this.props.user.role !== 'SuperAdmin' &&
      this.props.user.role !== 'AdminLv1' &&
      this.props.user.role !== 'AdminLv2' &&
      this.actAsOther
    ) {
      return;
    }

    this.props.actions.getInstruments(this.getCurrentUserId());
    this.gettingInstruments = true;
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.shareInstrumentPatients.complete && this.sharingInstrumentPatients) {
      this.sharingInstrumentPatients = false;

      const message =
        this.props.shareInstrumentPatients.sharePatients === true
          ? this.intl.formatMessage({
              id: 'devices.patientShared',
              defaultMessage: 'Instrument patients shared',
            })
          : this.intl.formatMessage({
              id: 'devices.patientNotShared',
              defaultMessage: 'Instrument patients not shared',
            });
      toastr.success(
        this.intl.formatMessage({ id: 'general.success', defaultMessage: 'Success' }),
        this.intl.formatMessage({ id: message }),
        toastrOptions
      );
    }

    if (nextProps.downloadFirmware.complete && this.downloadingFirmware) {
      this.downloadingFirmware = false;
      toastr.success(
        this.intl.formatMessage({ id: 'general.success', defaultMessage: 'Success' }),
        this.intl.formatMessage({
          id: 'devices.firmwareDownloaded',
          defaultMessage: 'Firmware downloaded',
        }),
        toastrOptions
      );
      this.setState({
        showDownloadFirmwareModal: false,
        showDownloadGatewayModal: false,
      });
    }

    if (nextProps.getInstruments.complete && this.gettingInstruments) {
      this.gettingInstruments = false;
      const instrumentSourceUserGroupIds = nextProps.instruments
        .map((instrument) => instrument.sourceUserGroupId)
        .filter(this.onlyUnique);

      this.props.actions.subscribeToInstrumentsChange(
        instrumentSourceUserGroupIds,
        this.getCurrentUserId()
      );
    }
  }

  componentWillUnmount() {
    const instrumentSourceUserGroupIds = this.props.instruments
      .map((instrument) => instrument.sourceUserGroupId)
      .filter(this.onlyUnique);

    this.props.actions.unsubscribeFromInstrumentsChange(instrumentSourceUserGroupIds);
  }

  getCurrentUserId() {
    return this.props.match.params && this.props.match.params.userId
      ? this.props.match.params.userId
      : this.props.user.id;
  }

  showRegisterInstrumentModal() {
    this.setState({
      showRegisterInstrumentModal: true,
      fullModal: this.props.instruments.length === 0,
    });
  }

  hideRegisterInstrumentModal(reloadInstruments) {
    this.setState({
      showRegisterInstrumentModal: false,
      fullModal: false,
    });

    if (reloadInstruments === true) {
      this.props.actions.getInstruments(this.getCurrentUserId());
    }

    return true;
  }

  shareInstrumentPatients(instrumentId, share) {
    this.sharingInstrumentPatients = true;
    this.props.actions.shareInstrumentPatients(
      this.getCurrentUserId(),
      instrumentId,
      share,
      this.actAsOther
    );
  }

  render() {
    //Cannot act as if not SuperAdmin or AdminLvX
    if (
      this.props.user.role !== 'SuperAdmin' &&
      this.props.user.role !== 'AdminLv1' &&
      this.props.user.role !== 'AdminLv2' &&
      this.actAsOther
    ) {
      return null;
    }
    const demo = this.props.user.role === 'Demo' ? true : false;

    const headerButtonsRight = [
      {
        label: this.intl.formatMessage({ id: 'devices.addNew', defaultMessage: 'Add new' }),
        icon: 'add',
        action: this.showRegisterInstrumentModal,
      },
    ];
    return (
      <div>
        <Header
          title={
            this.intl.formatMessage({
              id: 'devices.Instruments',
              defaultMessage: 'INSTRUMENTS',
            }) + (this.actAsOther ? ' (Admin)' : '')
          }
          rightButtons={headerButtonsRight}
        />
        <Section>
          <SectionInner>
            <Devices
              actAsOtherId={
                this.props.match.params && this.props.match.params.userId
                  ? this.props.match.params.userId
                  : null
              }
            />
          </SectionInner>
        </Section>

        {this.props.getInstruments.busy ? (
          <Spinner className={styles.spinnerBackground} />
        ) : (
          <Section>
            <SectionInner>
              {/* <PanelWrapper>{this.renderInstruments()}</PanelWrapper> */}
            </SectionInner>
          </Section>
        )}
        <RegisterInstrumentModal
          fullModal={this.state.fullModal}
          demo={demo}
          show={this.state.showRegisterInstrumentModal}
          hide={this.hideRegisterInstrumentModal}
          actAsOtherId={
            this.props.match.params && this.props.match.params.userId
              ? this.props.match.params.userId
              : null
          }
          downloadGateway={this.showDownloadGatewayModal}
        />
      </div>
    );
  }
}

function mapState(state) {
  return {
    locale: state.translation.locale,
    user: state.user.user,
    getInstruments: state.instrument.getInstruments,
    instruments: state.instrument.instruments,
    registerInstrument: state.instrument.registerInstrument,
    shareInstrumentPatients: state.instrument.shareInstrumentPatients,
    downloadFirmware: state.firmware.downloadFirmware,
  };
}

function mapDispatch(dispatch) {
  return {
    actions: bindActionCreators(
      { ...instrumentActions, ...firmwareActions, ...accountActions },
      dispatch
    ),
  };
}

export default connect(mapState, mapDispatch)(injectIntl(DevicesPage));
